import { WORDPRESS_API_JSON } from "shared/constants/api";

export const getNewsPost = async ({
  postId,
  signal
}) => {
  const response = await fetch(
    `${WORDPRESS_API_JSON}/posts/${postId}`,
    { signal }
  );

  if (!response.ok) {
    throw new Error(
      "Nie udało się pobrać aktualności."
    );
  }

  return response.json();
};

export const getAllCategories = async ({
  signal
} = {}) => {
  const response = await fetch(
    `${WORDPRESS_API_JSON}/categories?per_page=100`,
    { signal }
  );

  if (!response.ok) {
    throw new Error(
      "Nie udało się pobrać kategorii."
    );
  }

  return response.json();
};


export const getAllPosts = async ({
  signal
} = {}) => {
  const perPage = 100;

  const firstResponse = await fetch(
    `${WORDPRESS_API_JSON}/posts?per_page=${perPage}&page=1`,
    { signal }
  );

  if (!firstResponse.ok) {
    throw new Error(
      "Nie udało się pobrać postów."
    );
  }

  const firstPosts = await firstResponse.json();

  const totalPages = Number(
    firstResponse.headers.get(
      "X-WP-TotalPages"
    ) || 1
  );

  if (totalPages <= 1) {
    return firstPosts;
  }

  const requests = [];

  for (
    let page = 2;
    page <= totalPages;
    page += 1
  ) {
    requests.push(
      fetch(
        `${WORDPRESS_API_JSON}/posts?per_page=${perPage}&page=${page}`,
        { signal }
      )
    );
  }

  const responses = await Promise.all(requests);

  responses.forEach((response) => {
    if (!response.ok) {
      throw new Error(
        "Nie udało się pobrać wszystkich postów."
      );
    }
  });

  const pages = await Promise.all(
    responses.map((response) =>
      response.json()
    )
  );

  return [
    ...firstPosts,
    ...pages.flat()
  ];
};